import React from 'react'

import { Allowed } from '~/src/Flags'
import NotFound from '~/src/Routes/NotFound'

const FlagAccountCreationWrapper = ({
  handler: Handler
}) => (
  <Allowed features="ACCOUNT_CREATION" Fallback={NotFound}>
    <Handler />
  </Allowed>
)

export default FlagAccountCreationWrapper
